import { Banner } from "../../components/Banner";

const Unauthorized = () => (
  <div className='flex flex-col min-h-screen'>
    <Banner header='Access denied' />
    <div className='flex flex-1 items-center justify-center p-8'>
      <p className='text-center text-gray-700 text-lg max-w-lg'>
        You do not have permission to access this application. Contact your administrator if
        you believe this is an error.
      </p>
    </div>
  </div>
);

export default Unauthorized;
